import React from "react";
import Typography from '@material-ui/core/Typography';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  Label,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";

export default function ReportBarChart(props){    
    const { reports, mode, colors } = props;    
        
    return (
        <div>
            <Typography variant="caption" display="block" gutterBottom style={{textAlign: "right"}}>
                Servers usage.
            </Typography>
            <ResponsiveContainer aspect={2.2}>
                <BarChart
                    data={reports}
                    margin={{ top: 5, right: 10, left: 10, bottom: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="core">
                    <Label position="bottom" style={{ textAnchor: 'middle' }}>
                        Servers Cores
                    </Label>
                    </XAxis>
                    <YAxis>
                    <Label angle={270} position='left' style={{ textAnchor: 'middle' }}>
                        {mode === "min" ? "Time (min)": "Coins"}
                    </Label>
                    </YAxis>
                    <Tooltip />
                    <Bar dataKey={mode} fill="#8884d8">
                        {
                            reports.map((info) => <Cell fill={colors[info.core]} />)
                        }
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
        );
}
